<template>
    <div>
        <vs-row class="cardGeneral cardReportes">
            <vs-col sm="12" lg="10">
                <h4>Inscripción Masiva por Grupo Administrativo</h4>
            </vs-col>
            <vs-row class="mt-4">
                <vs-col sm="12" lg="3">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select :loading="loadingInstitucion" filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" @input="getCicloEscolar()" >
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select :loading="loadingCiclo" filter class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" >
                            <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                Requerido
                            </template>
                            <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="3">
                    <form autocomplete="off">
                        <label for="grupo" class="labelInput">
                            Grupo
                        </label>
                        <div style="position: relative">
                            <vs-select
                                :loading="loadingGrupo"
                                filter
                                class="pt-0"
                                id="grupo"
                                placeholder="Seleccionar grupo"
                                :key="gruposId"
                                v-model="grupo"
                                :disabled="!grupos.length">
                                <template #message-danger v-if="errorFields.includes('grupo')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                    <vs-button
                        @click="getInscripcionMasiva()"
                    >
                        <i class="fas fa-search mr-2"></i>Buscar
                    </vs-button>
                </vs-col>
            </vs-row>
            <masivo :users="inscripcion" :institucion="institucion" :grupo="grupo" :cicloEscolar="cicloEscolar" :ciclosEscolares="ciclosEscolares"  @refreshTable="refreshTable"></masivo>
        </vs-row>
    </div>
</template>
<script>
import servicios from '../../../api/requests/servicios'
import masivo from './tabla-masivo.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            errorInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            errorCiclo: false,
            grupo: '',
            grupos: [],
            gruposId: (new Date()).getTime(),
            errorGrupo: false,
            inscripcion: [],
            errorFields: [],
            loadingInstitucion: false,
            loadingCiclo: false,
            loadingGrupo: false
        }
    },
    created(){
        this.getInstituciones()
    },
    components: {
        masivo
    },
    methods: {
        refreshTable(){
            this.getInscripcionMasiva()
        },
        async getInstituciones(){
            this.loadingInstitucion = true
            try {
                const response = await servicios.getInstitucion()
                this.instituciones = response.data
                this.loadingInstitucion = false
            }
            catch{
                this.loadingInstitucion = false
            }
        },
        async getCicloEscolar() {
            this.loadingCiclo = true
            try{
                const { data: response } = await servicios.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }catch{
                this.loadingCiclo = false
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                this.loadingGrupo = true
                try {
                    let params = {
                        "ciclo_escolar_id": this.cicloEscolar
                    }
                    const { data: response } = await servicios.getGrupo(this.institucion, params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch{
                    this.loadingGrupo = false
                }
            }
        },
        async getInscripcionMasiva() {
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try {
                    let params = {
                        'institucion_id': this.institucion,
                        'ciclo_escolar_id': this.cicloEscolar,
                        'grupo_id': this.grupo
                    }
                    const { data: response } = await servicios.getInscripcionMasiva(params)
                    this.inscripcion = this.getEliminarNameKey(response)
                    loading.close()
                }
                catch{
                    
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.grupo) {
                this.errorFields.push('grupo')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
    },
    watch: {
        institucion() {
            this.getCicloEscolar
            this.grupo = ''
            if(this.cicloEscolar !== ''){
                this.getGrupo()
            }
        },
        cicloEscolar(){
            this.getGrupo()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
</style>